'use client'

import { BodyXS } from '@/components/atomic/text'

import { PlaceHolderContainer } from './styles'

interface ModelBuilderPlaceholderProps {
  text: string
}

export function ModelBuilderPlaceholder({
  text,
}: ModelBuilderPlaceholderProps) {
  return (
    <PlaceHolderContainer>
      <BodyXS>{text}</BodyXS>
    </PlaceHolderContainer>
  )
}
